"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var capitalizeFirstLetter = function (text) {
    return (text = text
        .toLowerCase()
        .split(' ')
        .map(function (s) {
        return s.charAt(0).toUpperCase() + s.substring(1);
    })
        .join(' '));
};
exports.capitalizeFirstLetter = capitalizeFirstLetter;
var hasHtmlTag = function (text) {
    return /<[a-z][\s\S]*>/i.test(text);
};
exports.hasHtmlTag = hasHtmlTag;
var stripHtmlTag = function (text) {
    if (!hasHtmlTag(text)) {
        return text;
    }
    var div = document.createElement('div');
    div.innerHTML = text;
    var outputText = div.textContent || div.innerText || '';
    return outputText;
};
exports.stripHtmlTag = stripHtmlTag;
var trunc = function (text, n, useWordBoundary) {
    if (text === void 0) { text = ''; }
    if (n === void 0) { n = 0; }
    if (useWordBoundary === void 0) { useWordBoundary = false; }
    if (text.length <= n) {
        return text;
    }
    var subString = text.substr(0, n - 1);
    return (useWordBoundary ? subString.substr(0, subString.lastIndexOf(' ')) : subString) + '...';
};
exports.trunc = trunc;
